import React from 'react';
import Header from "../components/Header";
import SimpleHeader from "../components/SimpleHeader";
import Footer from "../components/Footer";
import FinishedWork from "../components/FinishedWork";
import PageTitle from "../components/PageTitle";
import workDatabase from "../database/work.json";

const Work = () => {
    return (
        <>
            <PageTitle title='International Work' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"internationalWork"}
                    route={"internationalWork"}
                    url={"internationalWork"}
                />
                <div className='work-container flex col max-w'>
                    {workDatabase.map((year, index) => (
                        <>
                            <h2 key={index}>{year.year}</h2>
                            {year.components.map((work, index) => (
                                <FinishedWork
                                    key={'e' + index}
                                    projectName={work.projectName}
                                    school={work.school}
                                    number={work.number}
                                    date={work.date}
                                    pdfURL={work.pdfURL}
                                    imgName={work.imgName}
                                    content={work.content ? work.content : null}
                                    alignment={work.alignment ? work.alignment : null}
                                    facebookVideo={work.facebookVideo ? work.facebookVideo : null}
                                />
                            ))}
                        </>
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Work;